<template>
    <div class="h-100">
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">Complete Ento Data</h2>
            <p class="tw-italic tw-text-gray-700">
                Given a collection code, show all the Ento Data associated with
                it.
            </p>
        </b-container>

        <b-container fluid>
            <b-row>
                <b-col>
                    <b-form-input
                        label="Collection Code"
                        placeholder="Start typing collection code to filter, or double click to get list."
                        v-model="keyword"
                        list="cc-list"
                        size="lg"
                        @keypress.enter="search()"
                        @click:append="search()"
                    ></b-form-input>

                    <datalist id="cc-list">
                        <option
                            v-for="cCode in collectionCodes"
                            :key="cCode.id"
                        >
                            {{ cCode.collection_code }}
                        </option>
                    </datalist>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        @click="search()"
                        block
                        size="lg"
                        variant="success"
                    >
                        Search Code
                    </b-button>
                </b-col>
            </b-row>
        </b-container>

        <hr />

        <b-table ref="table" striped hover responsive :items="items"></b-table>

        <!-- :items="myProvider"
        :fields="fields"
        :busy.sync="loading"
        :current-page="options.currentPage"
        :per-page="options.perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc" -->
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import EntoDataHOT from "@/components/unitaid/ento-data/EntoDataHOT.vue";

import { mapActions } from "vuex";
import * as _ from "lodash";

export default {
    components: {
        EntoDataHOT,
    },
    mixins: [DashboardBaseTemplate],
    data: function () {
        return {
            keyword: "",
            collectionCode: "",
            collectionCodeStatus: "draft",
            collectionCodes: [],
            selectedCollectionCode: null,
            tabIndex: 0,
            formData: {},
            items: []
        };
    },
    mounted() {
        const that = this;

        that.getEntoCollectionCodes()
            .then((response) => {
                _.each(response.data, function (item) {
                    // if (item.status !== "draft") {
                    //     that.collectionCodes.push(item);
                    // }
                    that.collectionCodes.push(item);
                });

                that.keyword = that.$route.query.collectionCode
                    ? that.$route.query.collectionCode
                    : "";
                that.search();
            })
            .catch((error) => {
                HandleErrors.HandleErrors(error);
            });
    },
    methods: {
        ...mapActions("websheet", ["getEntoCollectionCodes", "getEntoData"]),
        search: function () {
            const that = this;
            that.selectedCollectionCode = _.find(that.collectionCodes, [
                "collection_code",
                that.keyword,
            ]);
            that.collectionCodeStatus = that.selectedCollectionCode.status;
            that.collectionCode = that.keyword;

            that.find();
        },
        find() {
            const that = this;
            // Set the request data.
            let data = {
                collection_code: that.collectionCode
            };

            that.getEntoData(data).then((response) => {
                let data = [];

                _.each(response.data, function (item) {
                    if (["locked", "edit", "rejected"].indexOf(item.status) >= 0) {
                        data.push(item);
                    }
                });

                that.items = data;
            });
        },
    },
};
</script>

